import PowerActionType from '@signageos/actions/dist/Device/Power/PowerActionType';

export const PerformScheduledPowerAction = 'Front.Device.Power.PerformScheduledPowerAction';
export interface PerformScheduledPowerAction {
	type: typeof PerformScheduledPowerAction;
	powerType: PowerActionType;
}

export const TriggerDisplayPowerOn = 'Front.Device.Power.TriggerDisplayPowerOn';
export interface TriggerDisplayPowerOn {
	type: typeof TriggerDisplayPowerOn;
}

export const TriggerDisplayPowerOff = 'Front.Device.Power.TriggerDisplayPowerOff';
export interface TriggerDisplayPowerOff {
	type: typeof TriggerDisplayPowerOff;
}

export const TriggerAppletOn = 'Front.Device.Power.TriggerAppletOn';
export interface TriggerAppletOn {
	type: typeof TriggerAppletOn;
}

export const TriggerAppletOff = 'Front.Device.Power.TriggerAppletOff';
export interface TriggerAppletOff {
	type: typeof TriggerAppletOff;
	nextPowerOn?: Date | null;
}
